import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { IndexModule } from "./pages/index/index.module";
import { DevelopmentModule } from "./pages/development/development.module";
import { ContactModule } from "./pages/contact/contact.module";
import { ProductModule } from "./pages/product/product.module";
import { IntroModule } from "./pages/intro/intro.module";
import { FactoryModule } from "./pages/factory/factory.module";
import { EmployModule } from "./pages/employ/employ.module";
import { NetModule } from "./pages/net/net.module";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    IndexModule,
    DevelopmentModule,
    ContactModule,
    ProductModule,
    IntroModule,
    FactoryModule,
    EmployModule,
    NetModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
